/* AutoLift header search — site-wide lift-parts finder (Amazon-style, every page).

   Injects a search button + slide-down panel into the theme header. Lazily loads

   the compact model index (parts-index.js) on first open. Intent-aware matching

   (brand + lift-type phrases + model tokens). Results deep-link into

   /pages/parts-lookup#mfr=K&model=S; always offers native product search too. */

(function () {

  "use strict";

  if (window.__alHS) return; window.__alHS = 1;



  var CSS = ""

    + "#al-hs-btn{display:inline-flex;align-items:center;gap:10px;background:#fff;color:#777;border:2px solid #d6d6d6;border-radius:24px;padding:10px 18px;font-size:14px;font-weight:500;cursor:text;letter-spacing:.2px;line-height:1;min-width:240px;max-width:360px;text-align:left}"

    + "#al-hs-btn:hover{border-color:#e53935;box-shadow:0 2px 10px rgba(229,57,53,.12)}"

    + "#al-hs-btn svg{width:17px;height:17px;color:#e53935;flex-shrink:0}"

    + "#al-hs-btn span{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex:1}"

    + "@media(max-width:900px){#al-hs-btn{min-width:0;padding:9px 12px}#al-hs-btn span{display:none}}"

    + "#al-hs-panel{position:fixed;left:0;right:0;top:0;background:#fff;z-index:9999;box-shadow:0 12px 30px rgba(0,0,0,.25);transform:translateY(-110%);transition:transform .22s ease;padding:18px 16px 22px}"

    + "#al-hs-panel.on{transform:translateY(0)}"

    + "#al-hs-inner{max-width:860px;margin:0 auto;position:relative}"

    + "#al-hs-input{width:100%;padding:18px 56px 18px 22px;font-size:18px;border:3px solid #e53935;border-radius:12px;outline:none;box-sizing:border-box;color:#111;background:#fff}"

    + "#al-hs-close{position:absolute;right:14px;top:14px;background:none;border:none;font-size:22px;color:#888;cursor:pointer;line-height:1}"

    + "#al-hs-hint{color:#888;font-size:12px;margin:8px 2px 0}"

    + "#al-hs-res{max-height:55vh;overflow-y:auto;margin-top:10px;border-top:1px solid #eee}"

    + ".al-hs-row{display:flex;justify-content:space-between;align-items:center;padding:11px 10px;border-bottom:1px solid #f2f2f2;cursor:pointer;color:#111;text-decoration:none}"

    + ".al-hs-row:hover{background:#fef3f3}"

    + ".al-hs-t{font-weight:700;font-size:15px}"

    + ".al-hs-s{font-size:12px;color:#777}"

    + ".al-hs-row.alt .al-hs-t{color:#1565c0}"

    + "#al-hs-ov{position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:9998;display:none}"

    + "#al-hs-ov.on{display:block}";



  var TYPE_SYN = [

    [/(^|\s)(2|two)[\s-]*post/, "2-post", "2-Post"],

    [/(^|\s)(4|four)[\s-]*post/, "4-post", "4-Post"],

    [/in[\s-]*ground/, "ground", "Inground"],

    [/scissor/, "scissor", "Scissor"],

    [/mid[\s-]*rise/, "mid rise", "Mid-Rise"],

    [/(low|short)[\s-]*rise/, "low rise", "Low-Rise"],

    [/(rolling[\s-]*)?(bridge[\s-]*)?jack/, "jack", "Rolling Jack"],

    [/align/, "align", "Alignment"]

  ];



  function matcher(raw) {

    var IDX = window.AL_PIDX; if (!IDX) return null;

    var q = raw.toLowerCase(), typeNeedle = null, typeLabel = "";

    for (var i = 0; i < TYPE_SYN.length; i++) {

      if (TYPE_SYN[i][0].test(q)) { typeNeedle = TYPE_SYN[i][1]; typeLabel = TYPE_SYN[i][2]; q = q.replace(TYPE_SYN[i][0], " "); break; }

    }

    var brandKey = null;

    for (var k in IDX.n) {

      var bn = IDX.n[k].toLowerCase();

      if (q.indexOf(bn) !== -1) { brandKey = k; q = q.replace(bn, " "); break; }

    }

    var toks = q.replace(/\blifts?\b/g, " ").replace(/\bparts?\b/g, " ").split(/\s+/).filter(function (t) { return t; });

    var starts = [], contains = [];

    for (var i = 0; i < IDX.d.length; i++) {

      var g = IDX.d[i];

      if (brandKey && g[0] !== brandKey) continue;

      if (typeNeedle && (g[3] || "").toLowerCase().indexOf(typeNeedle) === -1) continue;

      var nm = g[1].toLowerCase(), sl = g[2].toLowerCase(), ok = true, pref = false;

      for (var t = 0; t < toks.length; t++) {

        var tk = toks[t];

        if (nm.indexOf(tk) === 0 || sl.indexOf(tk) === 0) pref = true;

        else if (nm.indexOf(tk) === -1 && sl.indexOf(tk) === -1) { ok = false; break; }

      }

      if (!ok) continue;

      (pref || !toks.length ? starts : contains).push(g);

      if (starts.length > 40) break;

    }

    return { brandKey: brandKey, typeLabel: typeLabel, models: starts.concat(contains) };

  }



  function el(tag, attrs, html) {

    var e = document.createElement(tag);

    for (var a in attrs) e.setAttribute(a, attrs[a]);

    if (html) e.innerHTML = html;

    return e;

  }



  function ensureIndex(cb) {

    if (window.AL_PIDX) return cb();

    var v = Math.floor(Date.now() / 86400000);

    var s = el("script", { src: "https://cdn.shopify.com/s/files/1/0819/7845/8365/t/1/assets/parts-index.js?v=b" + v });

    s.onload = cb; document.head.appendChild(s);

  }



  var SKU_RE = /^[A-Za-z]{0,4}[-_ ]?\d[A-Za-z0-9-_ ]*$/;

  function normSku(s) { return (s || "").toUpperCase().replace(/[^A-Z0-9]/g, ""); }

  function ensureSkuIdx(cb) {

    if (window.AL_SKUIDX) return cb();

    if (window.__alSkuLoading) { setTimeout(function () { ensureSkuIdx(cb); }, 200); return; }

    window.__alSkuLoading = 1;

    var s = el("script", { src: "https://cdn.shopify.com/s/files/1/0819/7845/8365/t/1/assets/parts-sku-index.js?v=b" + Math.floor(Date.now() / 86400000) });

    s.onload = cb; document.head.appendChild(s);

  }

  function skuRows(q) {

    var n = normSku(q); if (n.length < 4 || !window.AL_SKUIDX) return "";

    var hits = [];

    if (window.AL_SKUIDX[n]) hits.push([q.toUpperCase(), window.AL_SKUIDX[n]]);

    else { var c = 0; for (var k in window.AL_SKUIDX) { if (k.indexOf(n) === 0) { hits.push([k, window.AL_SKUIDX[k]]); if (++c >= 5) break; } } }

    var h = "";

    hits.forEach(function (x) {

      h += '<a class="al-hs-row" href="/products/' + x[1][0] + '"><div><div class="al-hs-t">Part ' + x[0] + (x[1][1] ? (" — $" + x[1][1]) : "") + '</div><div class="al-hs-s">View product →</div></div></a>';

    });

    return h;

  }



  /* Native product suggestions — searches the FULL store catalog (not just the
     lift-model / part-number indexes) so named products & accessories
     (e.g. "foam ramps") surface right in the dropdown. */
  function fmtMoney(s) {
    var n = parseFloat(s);
    if (isNaN(n)) return "";
    return "$" + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function injectProducts(q) {
    fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last")
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var inp = document.getElementById("al-hs-input");
        if (!inp || inp.value.trim() !== q) return; /* stale — user kept typing */
        var box = document.getElementById("al-hs-prod");
        if (!box) return;
        var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (!prods.length) { box.innerHTML = ""; return; }
        var h = "";
        prods.slice(0, 6).forEach(function (p) {
          var price = fmtMoney(p.price);
          var sub = (p.vendor || "") + (p.type ? (" • " + p.type) : "");
          h += '<a class="al-hs-row" href="' + p.url + '"><div><div class="al-hs-t">'
            + (p.title || "").replace(/[<>]/g, "") + '</div><div class="al-hs-s">' + sub
            + '</div></div>' + (price ? ('<div class="al-hs-s">' + price + '</div>') : '') + '</a>';
        });
        box.innerHTML = h;
      })
      .catch(function () { });
  }

  function render(q) {

    var res = document.getElementById("al-hs-res");

    if (!q) { res.innerHTML = ""; return; }

    var r = matcher(q);

    if (!r) return;

    var h = "";

    var IDX = window.AL_PIDX;

    if (SKU_RE.test(q) && normSku(q).length >= 4) {

      var pre = skuRows(q);

      if (pre) h += pre;

      else ensureSkuIdx(function () {

        var inp = document.getElementById("al-hs-input");

        if (inp && inp.value.trim() === q) render(q);

      });

    }

    if (r.brandKey) {

      var lbl = IDX.n[r.brandKey] + (r.typeLabel ? " " + r.typeLabel + " lifts" : "");

      h += '<a class="al-hs-row" href="/pages/parts-lookup#mfr=' + r.brandKey + '"><div><div class="al-hs-t">' + lbl + '</div><div class="al-hs-s">' + (r.models.length ? r.models.length + " matching models — browse parts breakdowns →" : "Browse parts breakdowns →") + "</div></div></a>";

    }

    r.models.slice(0, 12).forEach(function (g) {

      var s = (g[3] || "").replace("Above Ground / Surface Mount ", "").replace("In Ground ", "In-Ground ");

      h += '<a class="al-hs-row" href="/pages/parts-lookup#mfr=' + g[0] + "&model=" + encodeURIComponent(g[2]) + '"><div><div class="al-hs-t">' + g[1] + '</div><div class="al-hs-s">' + (IDX.n[g[0]] || g[0]) + (s ? " • " + s : "") + " — parts breakdown</div></div></a>";

    });

    h += '<div id="al-hs-prod"></div>';

    h += '<a class="al-hs-row alt" href="/search?q=' + encodeURIComponent(q) + '"><div><div class="al-hs-t">Search all store products for “' + q.replace(/[<>"]/g, "") + '”</div><div class="al-hs-s">lifts, parts, accessories</div></div></a>';

    res.innerHTML = h;

    injectProducts(q);

  }



  function boot() {

    var style = document.createElement("style"); style.textContent = CSS + "@keyframes al-spin{to{transform:rotate(360deg)}}"; document.head.appendChild(style);



    var ov = el("div", { id: "al-hs-ov" });

    var panel = el("div", { id: "al-hs-panel" },

      '<div id="al-hs-inner"><input id="al-hs-input" type="text" placeholder="Search lift model, brand, or part — e.g. SPOA10, BendPak 4-post…" autocomplete="off">'

      + '<button id="al-hs-close" aria-label="Close">✕</button>'

      + '<div id="al-hs-hint">Try a model number (SPOA10), a brand (BendPak), or “rotary 2 post lift”.</div>'

      + '<div id="al-hs-res"></div></div>');

    document.body.appendChild(ov); document.body.appendChild(panel);



    var btn = el("button", { id: "al-hs-btn", type: "button", "aria-label": "Search lift parts" },

      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.5" y2="16.5"/></svg><span>Search lifts, parts &amp; part numbers</span>');



    /* place in the header: prefer alongside the header icons/cart; fallbacks keep it visible on any layout */

    var host = document.querySelector("header .header__icons, header .header__icon-list, header nav + div, .header__row .header__icons")

      || document.querySelector("header .header__inline-menu, header nav")

      || document.querySelector("header") || document.body;

    btn.style.margin = "0 10px";

    host.insertBefore(btn, host.firstChild);



    function open() {

      panel.classList.add("on"); ov.classList.add("on");

      ensureIndex(function () { }); ensureSkuIdx(function () { });

      setTimeout(function () { document.getElementById("al-hs-input").focus(); }, 180);

    }

    function close() { panel.classList.remove("on"); ov.classList.remove("on"); }

    btn.addEventListener("click", open);

    ov.addEventListener("click", close);

    document.getElementById("al-hs-close").addEventListener("click", close);

    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

    /* same-page navigation: when already on the lookup page, plain <a href="#...">

       clicks with an unchanged hash do nothing — drive the page explicitly */

    document.getElementById("al-hs-res").addEventListener("click", function (e) {

      var a = e.target.closest && e.target.closest("a.al-hs-row");

      if (!a) return;

      var href = a.getAttribute("href") || "";

      var i = href.indexOf("/pages/parts-lookup#");

      if (i === -1) { e.preventDefault(); goLoading("Loading…", function(){ window.location.href = href; }); return; } /* product-search row etc: normal navigation */

      if (location.pathname.indexOf("/pages/parts-lookup") !== 0) { e.preventDefault(); goLoading("Loading parts…", function(){ window.location.href = href; }); return; } /* different page: navigate normally */

      e.preventDefault();

      var newHash = href.slice(href.indexOf("#") + 1);

      /* if a model view is open and we're jumping to a brand overview, back out first */

      var mv = document.getElementById("pl-mv");

      var bk = document.getElementById("pl-bk");

      if (mv && mv.classList.contains("on") && newHash.indexOf("model=") === -1 && bk) bk.click();

      var changed = ("#" + newHash) !== location.hash;

      location.hash = newHash;

      if (!changed) {

        try { window.dispatchEvent(new HashChangeEvent("hashchange")); }

        catch (_) { window.dispatchEvent(new Event("hashchange")); }

      }

      close();

    });



    /* Search v2 behavior is default as of 2026-07-29. Faster debounce + Enter goes to full query. */
    var inp = document.getElementById("al-hs-input"), tmr = null;
    function goLoading(msg, go){var res=document.getElementById("al-hs-res");if(res)res.innerHTML='<div style="display:flex;align-items:center;justify-content:center;gap:12px;padding:36px 10px;color:#555;font-size:15px"><span style="width:22px;height:22px;border:3px solid #eee;border-top-color:#e53935;border-radius:50%;display:inline-block;animation:al-spin .7s linear infinite"></span>'+(msg||"Loading…")+'</div>';if(go){var done=false,run=function(){if(done)return;done=true;go();};requestAnimationFrame(function(){requestAnimationFrame(run);});setTimeout(run,300);}}
    function nav(url){var hi=url.indexOf("/pages/parts-lookup#");if(hi!==-1&&location.pathname.indexOf("/pages/parts-lookup")===0){var nh=url.slice(url.indexOf("#")+1);var ch=("#"+nh)!==location.hash;location.hash=nh;if(!ch){try{window.dispatchEvent(new HashChangeEvent("hashchange"));}catch(_){window.dispatchEvent(new Event("hashchange"));}}close();}else{window.location.href=url;}}
    function goBest(q){
      var qn=q.toLowerCase().replace(/[^a-z0-9]/g,"");
      /* 1. exact LIFT-MODEL match (e.g. SPOA10) wins — even if a part shares that SKU */
      var r=window.AL_PIDX?matcher(q):null;
      if(r){var m0=r.models&&r.models[0];
        if(m0){var ms=(m0[2]||"").toLowerCase().replace(/[^a-z0-9]/g,""),mn=(m0[1]||"").toLowerCase().replace(/[^a-z0-9]/g,"");
          if(ms===qn||mn===qn){goLoading("Opening "+m0[1]+" parts…",function(){nav("/pages/parts-lookup#mfr="+m0[0]+"&model="+encodeURIComponent(m0[2]));});return;}}}
      /* 2. exact single PART number -> the product */
      var n=normSku(q);
      if(n.length>=4&&window.AL_SKUIDX&&window.AL_SKUIDX[n]){goLoading("Opening part "+q.toUpperCase()+"…",function(){window.location.href="/products/"+window.AL_SKUIDX[n][0];});return;}
      /* 3. keyword fallback */
      goLoading("Searching all products…",function(){window.location.href="/search?q="+encodeURIComponent(q);});
    }
    inp.addEventListener("input", function () {
      var v = this.value.trim();
      clearTimeout(tmr);
      tmr = setTimeout(function () { ensureIndex(function () { render(v); }); }, 60);
    });
    inp.addEventListener("keydown", function (e) {
      if (e.key !== "Enter") return;
      /* Cancel pending debounce, ALWAYS use CURRENT input value. */
      clearTimeout(tmr);
      var q = (inp.value || "").trim();
      if (!q) return;
      /* re-match the CURRENT value → route to the best destination (no stale-row race) */
      goBest(q);
    });

  }



  if (document.readyState !== "loading") boot();

  else document.addEventListener("DOMContentLoaded", boot);

})();

